import React, { Fragment, useState } from "react";
import ModalComponent from "../modalComponent/ModalComponent";
import { Alert, Button } from "antd";
import ConfirmButton from "../buttons/ConfirmButton";
import { uploadMedia } from "../../modules/presence/api/api";
import PropTypes from "prop-types";

const UploadForm = props => {
  const [fileModalErrorVisible, setFileModalErrorVisible] = useState(false);
  const [fileModalErrorMsg, setFileModalErrorMsg] = useState("");
  const [file, setFile] = useState("");
  const [uploading, setUploading] = useState(false);

  return (
    <div>
      {fileModalErrorVisible && (
        <Alert style={{ marginBottom: 10 }} message={fileModalErrorMsg} type="error" closable />
      )}
      <div>Choisissez ci-dessous votre fichier.</div>
      <div style={{ marginTop: 15 }}>
        <input
          accept=".jpeg,.jpg,.png,.pdf"
          type="file"
          name="file"
          id="file"
          onChange={e => {
            let _files = e.target.files || e.dataTransfer.files;
            if (!_files.length) return;
            const file = _files[0];
            if (file.size > 20 * 1024 * 1024) {
              setFileModalErrorVisible(true);
              setFileModalErrorMsg("Le fichier sélectionné est trop volumineux (max 20mo)");
            } else {
              setFile(file);
              setFileModalErrorVisible(false);
            }
          }}
          className="p-import-file"
        />
        <label htmlFor="file" className="p-import-btn">
          {file ? file.name : "Choisir un fichier"}
        </label>
      </div>
      <div style={{ marginTop: 15 }}>
        <Button
          type={"primary"}
          loading={uploading}
          large={true}
          onClick={async () => {
            if (uploading) {
              return false;
            }
            setUploading(true);
            let fileMetaData;
            try {
              fileMetaData = await uploadMedia(file);
              //setFileModalIsVisible(false);
              await props.onUploadComplete(fileMetaData);
              setUploading(false);
              setFile("");
            } catch (e) {
              //setFileModalErrorVisible(true);
              setFileModalErrorMsg("Une erreur est survenue");
              await props.onUploadComplete(fileMetaData, e);
              setUploading(false);
              setFile("");
            }
          }}
        >
          Enregistrer
        </Button>
      </div>
    </div>
  );
};

UploadForm.propTypes = {
  onUploadComplete: PropTypes.func
};

export default UploadForm;



// WEBPACK FOOTER //
// src/components/upload/UploadForm.js